import * as React from 'react';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import { showCostBreakdown } from '../../../../actions/modalActions';
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import { CLAIM_HISTORY_V2 } from '../../../../routes/routes';
import { HashLink as Link } from 'react-router-hash-link';
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class ClaimProcessing extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleShowCostBreakdown() {
        this.props.handleShowCostBreakdown();
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    render() {
        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="ClaimProcessing">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    <Card className="content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="claims-noc-step-header-icon-area">
                                        {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />}
                                        {(this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src="/my-policy/Images/Claims/Numbers/step-success-32x32px.svg" alt="Step 5: Completed" title="Step 5: Completed" />}
                                    </div>
                                    <div className="col nopa claims-noc-step-header-title-area">
                                        <h3>Claim processing</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 nopa mt-10px">
                                {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <p className="font-weight-500 mb-0px">Oh looky, it's time to process your claim.<br /><br />
                                    {!isMobile &&
                                        <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                    }
                                    {isMobile &&
                                        <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                    }
                                </p>}
                                {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && !this.props.claimSubmit.selectedClaimProgressStep.repudiationReason) && <p className="font-weight-500 mb-0px">Hooray, your claim = authorised. You can have a look at the next step.</p>}
                                {!this.props.claimSubmit.selectedClaimProgressStep.repudiationReason && <hr className="mt-15px mb-15px claims-v2-hr-2px" />}
                            </div>
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col-12 nopa">
                                        {!this.props.claimSubmit.selectedClaimProgressStep.repudiationReason && <p className="card-subheading mb-0px">Where we’re at</p>}
                                    </div>
                                    {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <div className="mt-10px">
                                        <p className="text-16 text-red mb-15px">We’re validating your claim</p>
                                        <p className="font-weigtht-500 mb-0px">Our team's just busy checking the info you gave us when you told us about your claim</p>
                                    </div>}
                                    {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && !this.props.claimSubmit.selectedClaimProgressStep.repudiationReason) && <div className="mt-10px">
                                        <p className="text-16 text-red mb-0px">Your claim has been authorised (boom!)</p>
                                    </div>}
                                </div>
                                {!this.props.claimSubmit.selectedClaimProgressStep.repudiationReason && <hr className="mt-15px mb-15px claims-v2-hr-2px" />}
                            </div>
                            {!isMobile && (this.props.claimSubmit.selectedClaimProgressStep.claimType !== "Motor Vehicle W/O") &&
                                <div className="col-12 nopa">
                                    <div className="row noma align-items-center">
                                        <div className="col nopa">
                                            <p className="card-subheading align-self-center mb-0px">Damage amount<img onClick={() => this.handleShowCostBreakdown()} className="completionTooltip ml-3 mb-0" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" /></p>
                                        </div>
                                        <div className="col nopa">
                                            <p className="text-red align-self-center text-right text-16 mb-0px">{this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.damageAmount === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.damageAmount.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {isMobile && (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && (this.props.claimSubmit.selectedClaimProgressStep.claimType !== "Motor Vehicle W/O") &&
                                < div className="col-12 nopa">
                                    <div className="row noma align-items-center">
                                        <div className="col-10 nopa">
                                            <p className="card-subheading align-self-center text-left mb-0px">Damage amount</p>
                                        </div>
                                        <div className="col-2 nopa align-self-center text-right">
                                            <img onClick={() => this.handleShowCostBreakdown()} className="completionTooltip mb-0" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" />
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <p className="text-red align-self-center text-left text-16 mb-0px ">{this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.damageAmount === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.damageAmount.toFixed(2))}</p>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Driveable" || this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Non-Driveable") &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <p className="claim-step-subtitle col-sm-12 col-md-6 col-lg-6 mb-0px nopa">You’ll pay</p>
                                        <p className="claim-type col-sm-12 col-md-6 col-lg-6 mb-0 text-red text-16 mb-0px mobile-mt-10px nopa">{this.props.profile.currencySymbol}&nbsp;{this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.totalExcess.toFixed(2)}</p>
                                    </div>
                                    <div className="row noma mt-20px">
                                        <div className="col nopa">
                                            <p className="card-subheading text-bold">Excess breakdown</p>
                                        </div>
                                    </div>
                                    <div className="row noma mb-10px">
                                        <div className="col nopa">
                                            <p className="font-weight-500 mb-0px">Basic excess</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.basicExcess === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.basicExcess.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <div className="row noma mb-10px">
                                        <div className="col nopa text-left">
                                            <p className="font-weight-500 mb-0px">Additional excess/es</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.additionalExcess === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.additionalExcess.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <div className="row noma">
                                        <div className="col nopa text-left">
                                            <p className="font-weight-500 mb-0px">Other contribution/s</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.otherContributions === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.otherContributions.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle W/O") &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <p className="claim-step-subtitle col-sm-12 col-md-6 col-lg-6 mb-0px nopa">You’ll pay</p>
                                    <p className="claim-type col-sm-12 col-md-6 col-lg-6 mb-0 text-red text-right text-16 mb-0px nopa">{this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.totalExcess === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.totalExcess.toFixed(2))}</p>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.paymentAmount) && (this.props.claimSubmit.selectedClaimProgressStep.claimType !== "Motor Vehicle W/O") &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <p className="claim-step-subtitle col-md-6 nopa">We’ll pay</p>

                                        {(this.props.claimSubmit.selectedClaimProgressStep.claimType !== "Motor Vehicle W/O") &&
                                            <p className="claim-type col-sm-12 col-md-6 col-lg-6 mb-0 text-red text-16 mb-0px mobile-mt-10px nopa">{this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.paymentAmount === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimProcessingStep.paymentAmount.toFixed(2))}</p>
                                        }
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle W/O") &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <p className="claim-step-subtitle col-6 nopa">We’ll pay</p>
                                    <p className="mb-0px nopa">We're busy processing your claim, and we'll chat to you soon about how we'll pay it out</p>
                                    </div>
                                    <  hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="next-step-subheading mb-0">Next step</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <ClaimsNextStep />
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleShowCostBreakdown: () => dispatch(showCostBreakdown()),
        handleClaimsBackClick: () => dispatch(getOverview()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimProcessing);
